import {Component, OnInit} from '@angular/core';
import { EmergencyService } from './emergency.service'
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-tabs',
  templateUrl: './emergency.component.html',
})
export class EmergencyComponent implements OnInit {

  contacts:any;

  closeResult: string;
  searchText:string;

  constructor(private modalService: NgbModal,
              private emergencyService: EmergencyService) {
  }

   ngOnInit() {
    this.contacts = this.emergencyService.contacts
  }

}
